import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const INIT = { title: "", company: "", location: "", url: "", description: "", salary_min: "", salary_max: "", salary_currency: "INR",
  salary_period: "year", salary_type: "base", remote: "no" };

export function ManualJobDialog({ open, onOpenChange, onCreated }) {
  const [f, setF] = useState(INIT);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const num = (v) => (v === "" ? null : Number(v));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/jobs/manual", { ...f, salary_min: num(f.salary_min), salary_max: num(f.salary_max), remote: f.remote === "yes",
        remote_scope: f.remote === "yes" ? "India" : "", salary_type: f.salary_min || f.salary_max ? f.salary_type : null });
      toast.success("Job added and scored");
      setF(INIT);
      onOpenChange(false);
      onCreated?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const field = (k, label, props = {}) => (
    <div className="space-y-1.5"><Label htmlFor={`mj-${k}`}>{label}</Label><Input id={`mj-${k}`} data-testid={`manual-job-${k}`} value={f[k]} onChange={set(k)} {...props} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-xl" data-testid="manual-job-dialog">
        <DialogHeader><DialogTitle>Add a job manually</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {field("title", "Job title", { required: true })}
          {field("company", "Company", { required: true })}
          {field("location", "Location")}
          <div className="space-y-1.5"><Label>Remote, open to India?</Label>
            <Select value={f.remote} onValueChange={set("remote")}><SelectTrigger data-testid="manual-job-remote"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="no">No / on-site</SelectItem><SelectItem value="yes">Yes, remote open to India</SelectItem></SelectContent></Select></div>
          <div className="sm:col-span-2">{field("url", "Original posting URL", { required: true, type: "url", placeholder: "https://" })}</div>
          {field("salary_min", "Salary min (leave blank if unknown)", { type: "number", min: 0 })}
          {field("salary_max", "Salary max", { type: "number", min: 0 })}
          {field("salary_currency", "Currency")}
          <div className="space-y-1.5"><Label>Pay type</Label>
            <Select value={f.salary_type} onValueChange={set("salary_type")}><SelectTrigger data-testid="manual-job-salary-type"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="base">Guaranteed base / fixed</SelectItem><SelectItem value="ote">OTE incl. variable</SelectItem>
                <SelectItem value="equity">Includes equity</SelectItem><SelectItem value="unknown">Unclear</SelectItem></SelectContent></Select></div>
          <div className="space-y-1.5 sm:col-span-2"><Label htmlFor="mj-desc">Job description</Label>
            <Textarea id="mj-desc" rows={6} data-testid="manual-job-description" value={f.description} onChange={set("description")} /></div>
          <Button className="sm:col-span-2" disabled={busy} data-testid="manual-job-submit">Add job</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
